import(/* webpackMode: "eager" */ "/vercel/path0/src/app/debug/page.tsx");
